module.exports = __webpack_public_path__ + "static/RST-Schiebemuffe-12-6mm-e4baadee58fae91f3c02c642ac4ab4a6.jpg";